import { useTranslation } from 'react-i18next';
import { Boxes } from 'lucide-react';

import { Empty, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from '@/components/ui/empty';

/**
 * Placeholder for the *Details of Transportation* tab (pallet receipt).
 *
 * The tab exists so the modal's shape matches the legacy dialog and so the work
 * has a home, but building / confirming pallets at reception is deliberately out
 * of scope.
 */
export function TransportationDetailsPlaceholder() {
  const { t } = useTranslation();

  return (
    <Empty className="border border-dashed">
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <Boxes />
        </EmptyMedia>
        <EmptyTitle>{t('onlinesrf.transport.details.label', 'Details of Transportation')}</EmptyTitle>
        <EmptyDescription>
          {t(
            'receive.confirm.transport.placeholder',
            'Building and confirming pallets at reception is not available yet. Record the quantities on the Items tab.'
          )}
        </EmptyDescription>
      </EmptyHeader>
    </Empty>
  );
}
